import React, { useState, useEffect, useRef } from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import { useHistory } from 'react-router-dom';


const CreateStockOutward = (props) => {
    debugger;
    const classes = useStyles();
    const [Mode, setMode] = useState("");
    const [DocumentNo, setDocumentNo] = useState("");
    const [DocumentDate, setDocumentDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [DocumentType, setDocumentType] = useState();
    const [TransactionType, setTransactionType] = useState();
    const [TransactionStorecmb, setTransactionStorecmb] = useState();
    const [AccountName, setAccountName] = useState({ id: props.AccountID, AccountName: props.AccountName });
    const [AccountID, setAccountID] = useState('');
    const [ACAccount, setACAccount] = useState([]);
    const [TransactionStoreID, setTransactionStoreID] = useState();
    const [ToStoreID, setToStoreID] = useState();
    const [ToStorecmb, setToStorecmb] = useState();
    const [responseGetData, fetchDataGetData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [Accountcmb, setAccountcmb] = useState([]);
    const [response, fetchData] = UseFetchData();
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const [disableStore, setdisableStore] = useState(false);
    const ref = useRef(null);
    const history = useHistory();

    const validationSchema = Yup.object({
        DocumentDate: Yup.string().required("Required!"),
        TransactionType: Yup.string().required("Required!"),
    });


    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        // setCursor(e.target.selectionStart);
        onChange && onChange(e);
    };

    const onSubmit = (values) => {
        // setMode("Insert");
        debugger;
        var UpdatedByID = sessionStorage.UID;
        var CreatedBYID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("InventoryDocumentID", props.InventoryDocumentID);
        bodyFormData.append("DocumentNo", values.DocumentNo);
        bodyFormData.append("DocumentDate", values.DocumentDate);
        bodyFormData.append("DocumentType", values.DocumentType);
        if (values.AccountID == "" || values.AccountID == undefined) {
            var AID = "";
            bodyFormData.append("CustomerID", AID);
        } else {
            bodyFormData.append("CustomerID", values.AccountID);
        }
        bodyFormData.append("TransactionType", values.TransactionType);
        bodyFormData.append("TransactionStoreID", values.TransactionStoreID);
        if (values.ToStoreID == "" || values.ToStoreID == undefined) {
            var TSID = "";
            bodyFormData.append("ToStoreID", TSID);
        } else {
            bodyFormData.append("ToStoreID", values.ToStoreID);
        }
        bodyFormData.append("ModifiedByID", UpdatedByID);
        bodyFormData.append("CreatedBYID", CreatedBYID);
        // setDisableSaveBtn(true);
        fetchData("StockOutward/Save", bodyFormData);
    };

    const GetByIDData = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("InventoryDocumentID", props.InventoryDocumentID);
        fetchDataGetData("StockOutward/GetByID", bodyFormData);
    };


    const GetComboData = () => {
        fetchComboData("StockOutward/ComboDataCreateSO");
    };

    const DocumentTypeOption = [
        { key: "Against Challan-Returnable", value: "Against Challan-Returnable" },
        { key: "Against Invoice", value: "Against Invoice" },
        { key: "Stock Transfer Out", value: "Stock Transfer Out" },
    ];

    const DocumentTypeData = () => {
        let DocumentType = DocumentTypeOption.map((data) => (
            <option key={data.key} value={data.value}>
                {data.key}
            </option>
        ));
        return DocumentType;
    };

    const TrasactionTypeOption = [
        { key: "Stock Transfer Out", value: "Stock Transfer Out" },
        // { key: "Stock Transfer In", value: "Stock Transfer In" },
        // { key: "Stock Adjustment", value: "Stock Adjustment" },
    ];

    const TrasactionTypeData = () => {
        let TrasactionType = TrasactionTypeOption.map((data) => (
            <option key={data.key} value={data.value}>
                {data.key}
            </option>
        ));
        return TrasactionType;
    };

    useEffect(() => {
        debugger;
        GetComboData();
        if (props.InventoryDocumentID !== "" && props.Mode === "Update") {
            GetByIDData();
        }
        if (sessionStorage.UserType == "Admin") {
            setdisableStore(false);
        } else {
            setTransactionStoreID(sessionStorage.StoreID === null ? "" : sessionStorage.StoreID);
            setdisableStore(true);
        }

    }, []);


    const ToStoreData = (options) => {
        if (options !== undefined) {
            let ToStore = options.map((data) => (
                <option key={data.StoreName} value={data.StoreID}>
                    {data.StoreName}
                </option>
            ));
            setToStorecmb(ToStore);
        }
    };

    // const CustomerData = (options) => {
    //     if (options !== undefined) {
    //         let User = options.map((data) => (
    //             <option key={data.UserName} value={data.UserID}>
    //                 {data.UserName}
    //             </option>
    //         ));
    //         setCustomercmb(User);
    //     }
    // };

    const StoreData = (options) => {
        if (options !== undefined) {
            let Store = options.map((data) => (
                <option key={data.StoreName} value={data.StoreID}>
                    {data.StoreName}
                </option>
            ));
            setTransactionStorecmb(Store);
        }
    };

    useEffect(() => {
        debugger;
        if (response.Response === true) {
            alert("Data Saved Succesfully.");
            props.PopulateData();
            props.setOpen(false);
            if (Mode === "Update") {

            } else {
                var InventoryDocumentID = response.ID;
                history.push('StockOutwards/StockOutwardView', { InventoryDocumentID });
            }
        }
        else if (response.Response === false) {
            if (response.Message.includes("Already") === true) {
                alert(response.Message);
            } else {
                alert("Failed.");
            }
        }
    }, [response]);

    const onAccountSelectChange = React.useCallback((e, ACData) => {
        setAccountID(ACData.id);
        setAccountName(ACData);
    }, []);



    useEffect(() => {
        debugger;
        if (responseGetData !== undefined && responseGetData.length > 0) {
            setDocumentNo(responseGetData[0].DocumentNo);
            setDocumentDate(
                responseGetData[0].DocumentDate === null
                    ? ""
                    : Moment(responseGetData[0].DocumentDate).format("YYYY-MM-DD")
            );
            setDocumentType(responseGetData[0].DocumentType === null ? "" : responseGetData[0].DocumentType);
            setTransactionStoreID(responseGetData[0].TransactionStoreID === null ? "" : responseGetData[0].TransactionStoreID);
            // setCustomerID(responseGetData[0].CustomerID === null ? "" : responseGetData[0].CustomerID);
            setToStoreID(
                responseGetData[0].ToStoreID === null ? "" : responseGetData[0].ToStoreID
            );
            setTransactionType(responseGetData[0].TransactionType === null ? "" : responseGetData[0].TransactionType);
            setAccountID(responseGetData[0].CustomerID === null ? "" : responseGetData[0].CustomerID);
            setAccountName({ id: responseGetData[0].CustomerID, List: responseGetData[0].AccountName });

        }
    }, [responseGetData]);


    useEffect(() => {
        debugger;
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse['CmbStore'] !== undefined && ComboDataResponse['CmbStore'].length > 0) {
                // setLoading(false);
                StoreData(ComboDataResponse["CmbStore"]);
            } else {
                StoreData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
            if (ComboDataResponse['CmbStore'] !== undefined && ComboDataResponse['CmbStore'].length > 0) {
                // setLoading(false);
                ToStoreData(ComboDataResponse["CmbStore"]);
            } else {
                ToStoreData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
            if (ComboDataResponse['cmbAccount'] !== undefined && ComboDataResponse['cmbAccount'].length > 0) {
                setACAccount(ComboDataResponse['cmbAccount']);
            } else {
                setACAccount([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
        }
    }, [ComboDataResponse]);


    const onSelectChange = (e) => {
        debugger;
        //e.target.selectedOptions[0].label
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "AccountID") {
                setAccountID(targetvalue);
                // GetAccountData(targetvalue);
            }
            if (targetname === "TransactionStoreID") {
                setTransactionStoreID(targetvalue);
            }
            else if (targetname === "ToStoreID") {
                setToStoreID(targetvalue);
            }
        }
        else {
            if (targetname === "AccountID") {
                setAccountID(targetvalue);
                // GetAccountData(targetvalue);
            }
            if (targetname === "TransactionStoreID") {
                setTransactionStoreID("");
            }
            else if (targetname === "ToStoreID") {
                setToStoreID("");
            }
        }
    };

    let DocumentTypecmb = DocumentTypeData();
    let TransactionTypecmb = TrasactionTypeData();
    // let Customercmb = CustomerData();


    return (
        <div>
            <Formik
                initialValues={{
                    DocumentNo: DocumentNo,
                    DocumentDate: DocumentDate,
                    DocumentType: DocumentType,
                    TransactionStoreID: TransactionStoreID,
                    AccountID: AccountID,
                    ToStoreID: ToStoreID,
                    TransactionType: TransactionType,

                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <Form>
                            <Grid spacing={2} container direction="row">
                                <Grid item xs={3}>
                                    <label
                                        htmlFor={"DocumentNo"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"Document Num"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="DocumentNo"
                                        disabled={true}
                                        onChange={(e) => setDocumentNo(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1.5}>
                                    <label
                                        htmlFor={"DocumentDate"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Document Date"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="date"
                                        name="DocumentDate"
                                        disabled={true}
                                        onChange={(e) => setDocumentDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"DocumentType"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Document Type"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="DocumentType"
                                        options={DocumentTypecmb}
                                        onChange={(e) => setDocumentType(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"TransactionType"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Transaction Type"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="TransactionType"
                                        options={TransactionTypecmb}
                                        onChange={(e) => setTransactionType(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"TransactionStoreID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Transaction Store"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="TransactionStoreID"
                                        options={TransactionStorecmb}
                                        onChange={onSelectChange}
                                        disabled={disableStore}
                                    />
                                </Grid>
                                {/* <Grid item xs={3}>
                                    <label
                                        htmlFor={"CustomerID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Customer"}
                                    </label>
                                </Grid> */}
                                {/* <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="CustomerID"
                                        options={Customercmb}
                                        onChange={onSelectChange}
                                    />
                                </Grid> */}
                                {DocumentType === "Against Challan-Returnable" || DocumentType === "Against Invoice" ?
                                    <Grid item xs={3}>
                                        <label htmlFor={"AccountID"}
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                            }}>
                                            {"Customer"}
                                        </label>
                                    </Grid> :
                                    null}
                                {DocumentType === "Against Challan-Returnable" || DocumentType === "Against Invoice" ?
                                    <Grid item xs={8}>
                                        <BiztranControls.Autocomplete
                                            options={ACAccount}
                                            onChange={onAccountSelectChange}
                                            value={AccountName}
                                            name="AccountID"
                                        />
                                    </Grid> : null}
                                {DocumentType === "Stock Transfer Out" ?
                                    <Grid item xs={3} >
                                        <label
                                            htmlFor={"ToStoreID"}
                                            style={{
                                                display: "block",
                                                width: "100%",
                                            }}
                                        >
                                            {"To Store"}
                                        </label>
                                    </Grid>
                                    : null
                                }
                                {DocumentType === "Stock Transfer Out" ?
                                    <Grid item xs={8}>
                                        <BiztranControlsFormik
                                            control="select"
                                            options={ToStorecmb}
                                            name="ToStoreID"
                                            onChange={onSelectChange}
                                        />
                                    </Grid> : null
                                }

                            </Grid>
                            <Grid spacing={2} container direction="row">

                                <Grid item xs={12}>
                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",
                                            }}
                                        >
                                            <BiztranControls.Button
                                                text="SAVE"
                                                type="submit"
                                                // disabled={DisableSaveBtn}
                                                startIcon={<SaveIcon />}
                                            />
                                            <BiztranControls.Button
                                                text="CLOSE"
                                                startIcon={<CloseIcon />}
                                                onClick={() => {
                                                    props.setOpen(false);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    headertext: {
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2rem",
        paddingLeft: "30px",
        fontSize: "1.5rem",
        //marginTop: "-16px",
        marginBottom: "10px",
        marginLeft: "-24px",
        marginRight: "-24px",
        //   borderRadius: "1rem",
    },
}));

export default CreateStockOutward;
